'use client'
import { useState, useEffect } from 'react'
import Header from 'components/Header'
import CardsTorsPrivate from 'components/CardsTorsPrivate'
import { ONE } from 'config/apis'
import LoadingSpin from 'components/LoadingSpin'
import { useTorContext } from 'utils/context'
import NoResults from 'components/NoResults'

const Tornejos = () => {
  const defaultYear = new Date().getFullYear()
  const { torDetails } = useTorContext()
  const [tors, setTors] = useState([])
  const [loadMoreTors, setLoadMoreTors] = useState(false)

  const getData = async () => {
    try {
      const res = await fetch(
        `${ONE.TOR_LIST}?year=${defaultYear}&category=${torDetails.id}&page=1&limit=28&registrationOpen=yes`,
        ONE.HEADERS
      )
      const tors = await res.json()
      setTors(tors.Data)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getData()
  }, [setLoadMoreTors, loadMoreTors])

  return (
    <>
      <Header img={torDetails.headerImg} title="Tornejos" />
      <p></p>
      <div className="max-w-7xl mx-auto my-20">
        {tors ? (
          tors.length ? (
            <CardsTorsPrivate
              title="Propers tornejos"
              tors={tors}
              showCTA={true}
              setLoadMoreTors={setLoadMoreTors}
              isPublic={true}
            />
          ) : (
            <NoResults text="No hi ha tornejos" />
          )
        ) : (
          <LoadingSpin />
        )}
      </div>
    </>
  )
}

export default Tornejos
